<template>
  <Modal v-model="visible" :mask-closable="false" title="编辑" width="500px" class="my-modal">
    <div slot="header">
      <span class="modal-title">编辑</span>
      <span>
        可分配份额：
        <em class="table-btn def">{{ remainGiftNum }}</em>
      </span>
    </div>
    <Form v-if="visible" ref="formRef" :model="formData" :label-width="120" class="modal-form" @submit.native.prevent>
      <loading :isShow="loading" />
      <FormItem prop="remainGiftNum" label="剩余可用份额" :rules="[$units.formRule.required('分配次数不能为空',(trigger = 'blur')), $units.formRule.IntSort('请输入大于0的整数')]">
        <Input v-model="formData.remainGiftNum" placeholder="请输入" clearable />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" ghost @click="visible = false">取消</Button>
      <Button type="primary" @click="editNum">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    //商户剩余份额
    remainGiftNum: null
  },
  data: () => ({
    visible: false,
    loading: false,
    formData: {
      remainGiftNum: ''
    }
  }),
  components: {},
  created() {},
  methods: {
    open(row) {
      if (!this.$units.pointAction('recruiting_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      // this.formData = {
      //   remainGiftNum: row.remainGiftNum,
      //   id: row.id
      // };
      this.formData.remainGiftNum = row.remainGiftNum+''
      this.formData.id = row.id
      this.visible = true;
    },
    editNum() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if(this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            url: '/buz/giveawayProduct/updateSalesmanRemainGiftNum',
            type: 'POST',
            data: this.formData
          }).then(res => {
            this.visible = false;
            this.$emit('reload');
            this.$notice.success('修改成功');
          }).finally(()=>{
            window.setTimeout(()=>{
              this.loading = false;
            }, 500)
          });
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.my-modal /deep/ {
  .ivu-form-item-content {
    .ivu-input-number {
      width: 100%;
    }
  }
  .modal-title {
    color: #3c464f;
    font-weight: bold;
    margin-right: 15px;
  }
}
</style>